import { Component, OnInit, Renderer, ViewChild, ElementRef } from '@angular/core';
import { ROUTES } from '../../sidebar/sidebar.component';
import { Router } from '@angular/router';
import { Location} from '@angular/common';

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit{
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible = false;
    public usuario: string;
    public isCollapsed = true;
    @ViewChild("navbar-cmp", {static: false}) button;

    constructor(location:Location,
      private renderer : Renderer,
      private element : ElementRef,
      private router: Router)
    {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }

    ngOnInit(){
        this.listTitles = ROUTES.filter(listTitle => listTitle);
        var navbar : HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        this.router.events.subscribe((event) => {
          this.sidebarClose();
       });
       this.usuario = localStorage.getItem("ACCESS_USUARIO");
    }
    getTitle(){
      var title = this.location.prepareExternalUrl(this.location.path());
      const regex = /pbc\//;
      const veredas = /veredas\//;
      const regexAM = /acto-modificatorio\//
      const regexAME = /editar-acto-modificatorio\//
      if(title.charAt(0) === '#'){
          title = title.slice( 1 );
      }
      if(title.match(regex) != null) {
        return "Edición PBC"
      }
      if(title.match(regexAME) != null) {
        return "Editar Acto Modificatorio"
      }
      if(title.match(regexAM) != null) {
        return "Detalles Acto Modificatorio"
      }
      if (title == "/crear-pbc") {
        return "Crear PBC"
      }

      if(title.match(veredas) != null) {
        return "Edición vereda"
      }
      if (title == "/crear-vereda") {
        return "Crear Vereda"
      }
      if (title == "/crear-acto-modificatorio") {
        return "Crear Acto Modificatorio"
      }

      if (title == "/crear-acto-modificatorio") {
        return "Crear Acto Modificatorio"
      }
      for(var item = 0; item < this.listTitles.length; item++){
          if(this.listTitles[item].path === title){
              return this.listTitles[item].title;
          }
      }
      return title;
    }

    salir(){
      localStorage.removeItem('ACCESS_TOKEN');
      localStorage.removeItem('ACCESS_USUARIO');
      this.router.navigateByUrl('/autenticacion/salir');
    }

    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
      }
      sidebarOpen() {
          const toggleButton = this.toggleButton;
          const html = document.getElementsByTagName('html')[0];
          const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
          setTimeout(function(){
              toggleButton.classList.add('toggled');
          }, 500);

          html.classList.add('nav-open');
          if (window.innerWidth < 991) {
            mainPanel.style.position = 'fixed';
          }
          this.sidebarVisible = true;
      };
      sidebarClose() {
          const html = document.getElementsByTagName('html')[0];
          const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
          if (window.innerWidth < 991) {
            setTimeout(function(){
              mainPanel.style.position = '';
            }, 500);
          }
          this.toggleButton.classList.remove('toggled');
          this.sidebarVisible = false;
          html.classList.remove('nav-open');
      };
      collapse(){
        this.isCollapsed = !this.isCollapsed;
        const navbar = document.getElementsByTagName('nav')[0];
        console.log(navbar);
        if (!this.isCollapsed) {
          navbar.classList.remove('navbar-transparent');
          navbar.classList.add('bg-white');
        }else{
          navbar.classList.add('navbar-transparent');
          navbar.classList.remove('bg-white');
        }

      }

}
